export const DATE_FORMAT = Object.freeze({
  DEFAULT: 'MM/DD/YYYY',
  ISO_DATE_FORMAT: 'YYYY-MM-DD',
})
